import { createStore } from "vuex";

export default createStore({
	state: {
		showHeader: true,
		showFooter: true,
		showRouter: true,
	},
	getters: {},
	mutations: {
		setHeader(state, data) {
			state.showHeader = data;
		},
		setFooter(state, data) {
			state.showFooter = data;
		},
		setRouter(state, data) {
			state.showRouter = data;
		},
	},
	actions: {},
	modules: {},
});
